import { Button, FormInstance } from 'antd';
import { setStoredInput } from 'presentation/redux/features/CU/CU03101Slice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import React from 'react';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { MAX_NUMBER_VALUE_6_DIGITAL } from '..';
import { DetailProperty } from '../models/DetailProperty';
import { CountStep } from './CountStep';
import { InputRadioOption, InputWholeNumber } from './Input';

interface props {
    form: FormInstance<any>;
    detailProperty?: DetailProperty;
}
export const StepThree = ({ form }: props) => {
    const statusOptions = useAppSelector((state) => state.CU03101Slice.statusOptions);
    const dispatch = useAppDispatch();
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);

    const convertOptionsType = (
        value: any[],
    ): { value: number | string; name: number | string }[] => {
        const result: { value: number | string; name: number | string }[] = value.map(
            (element: any) => {
                return {
                    value: element.code,
                    name: element.codeName,
                };
            },
        );
        return result;
    };

    const onNext = async () => {
        try {
            await form.validateFields();
    
            const newStoredInput = {
                ...storedInput,
                rent: form.getFieldValue('rent'),
                commonServiceFee: form.getFieldValue('commonServiceFee'),
                presentCondDiv: form.getFieldValue('presentCondDiv'),
                page: 3,
                submit: true,
                prev: false,
            };
            dispatch(setStoredInput(newStoredInput));
        } catch (error) {
            console.error('Validation failed:', error);
        }
    };
    

    const onBack = () => {
        const newStoredInput = {
            ...storedInput,
            page: 3,
            prev: true,
            submit: true,
        };
        dispatch(setStoredInput(newStoredInput));
    };

    const customRule = [       
        {
        validator: (_: any, value: number) => {
            if (value < 1) {
                return Promise.reject(new Error('家賃は1円以上で入力してください。'));
            }
                return Promise.resolve();
            },
        }
]
    return (
        <React.Fragment>
            <CountStep current={3} title="賃貸状況（収入）を入力してください。" />
            <span>現在の状況が居住中・空室の場合は、想定家賃を入力してください</span>
            <InputWholeNumber
                label="家賃"
                name="rent"
                isRequired
                requiredMessage={getMessage('In_Required', '家賃')}
                addonAfter="円"
                rules={customRule}
                max={MAX_NUMBER_VALUE_6_DIGITAL}
                placeholder={PLACEHOLDER.RENT}
            />
            <InputWholeNumber
                label="共益費"
                name="commonServiceFee"
                isRequired
                requiredMessage={getMessage('In_Required', '共益費')}
                addonAfter="円"
                max={MAX_NUMBER_VALUE_6_DIGITAL}
                placeholder={PLACEHOLDER.COMMON_SERVICE_FEE}
            />
            <InputRadioOption
                label="現在の状況"
                name="presentCondDiv"
                isRequired
                requiredMessage={getMessage('In_Required', '現在の状況')}
                options={convertOptionsType(statusOptions)}
            />
            <section
                style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    display: 'flex',
                    gap: 20,
                }}
            >
                <Button
                    className="button-login-text"
                    style={{
                        width: 165.5,
                        height: 56,
                        marginTop: 16,
                        color: '#28323C',
                    }}
                    onClick={() => {
                        onBack();
                    }}
                >
                    戻る
                </Button>
                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: 165.5, height: 56, marginTop: 16 }}
                    onClick={() => onNext()}
                    htmlType="submit"
                >
                    次へ
                </Button>
            </section>
        </React.Fragment>
    );
};
